import { Assessment } from "./assessment";

export class Credential {
    name: string;
    assessmentGroup: string;
    sequence: string;
    status: string;
    assessments: Array<Assessment>;
    questionAnsweredCountForCurrentYearCRCE: number;
    questionCountForCurrentYearCRCE: number;

    questionAnsweredCountForPreviousYearCRCE: number;
    questionCountForPreviousYearCRCE: number;
    crcePreviousYear: number;
    crceYear: number;
}

export class CYD {
    asOfDate: string;
    ceuDueOn: string;
    ceuDueCompletedCount: number;
    ceuDueTotalCount: number;
    questionsCompletedCount: number;
    questionsTotalCount: number;
    currentScore: number;
    currentGraphScore: number;
    maxScore: number;
    highCutScore: number;
    lowCutScore: number;
    semEstimate: number;
    allowOptIn: boolean;
    totalAngoff: string;
    progressUpdatedBy: string;
    credentials: Array<Credential>;
}